import React from 'react';
import { Trans } from '@lingui/react/macro';
import { BaseStatusIndicatorProps } from '.';
import Indicator, { IndicatorColor } from '@/components/Indicator';
import { DocumentStatus } from '@/types';
import { useLingui } from '@lingui/react';

interface StatusIndicatorProps extends BaseStatusIndicatorProps {
    value: DocumentStatus;
    isArchived: boolean;
}

const colorMap: { [key in DocumentStatus]: IndicatorColor } = {
    Pending: 'warning',
    Rejected: 'danger',
    Approved: 'success',
};

const DocumentStatusIndicator: React.FC<StatusIndicatorProps> = ({ value, isArchived, children, ...rest }) => {
    const { _ } = useLingui();

    if (isArchived) {
        return (
            <Indicator color="secondary" {...rest}>
                <Trans>Archived</Trans>
            </Indicator>
        );
    }

    return (
        <Indicator color={colorMap[value]} {...rest}>
            {children || _({ id: `DocumentStatus.${value}` })}
        </Indicator>
    );
};

export default DocumentStatusIndicator;
